import { createFileRoute, notFound } from "@tanstack/react-router";

// Unknown pages under a retailer render the not-found view inside the admin
// shell (the organization route's notFoundComponent), not the bare root 404.
export const Route = createFileRoute("/_saas/app/_org/$organizationSlug/$")({
	loader: () => {
		throw notFound();
	},
});
